import React, { FC } from 'react';
import { Success as SuccessComponent } from '../../shared/components/Success/success.component';

export const Success: FC = () => {
  return <SuccessComponent />;
};
